import React, { useEffect, useState } from 'react';
import AuthTenantLoader from '../../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../../error/AuthTenantPageError';
import { Block, BlockHead, BlockTitle } from '../../../../components/Component';
import { RETRIVE_TENANT_BUDGET_ALLOCATION_DETAILS_API } from '../../../../api/api_data';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import { fail_retrieve_budget_allocation_main_details, loading_retrieve_budget_allocation_main_details, reset_retrieve_budget_allocation_main_details, success_retrieve_budget_allocation_main_details } from '../../../../reducers/auth_tenant/retrieve_budget_allocation_main_details_Slice';
import { RETRIEVE_TENANT_BUDGET_ALLOCATION_DETAILS_ERROR_MSG, RETRIEVE_TENANT_BUDGET_ALLOCATION_DETAILS_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import { formatNumber, messageToast } from '../../../../utils/Utils';
import { useSelector } from 'react-redux';
import * as app_consts from "../../../../utils/app_consts";
import moment from 'moment';

const MainAllocationsData = ({ tenant_info, user_info }) => {

 const [loading, setLoading] = useState(true);
 const [error, setError] = useState("");
 const [page_data, setPageData] = useState();

 const dispatch = useDispatch();
 const { id } = useParams();

 useEffect(() => {
  retrieve_budget_allocation_details();
 }, []);

 const retrieve_budget_allocation_details = () => {
  setError("");
  setLoading(true);
  dispatch(tenant_auth_actions_helper(loading_retrieve_budget_allocation_main_details, success_retrieve_budget_allocation_main_details, fail_retrieve_budget_allocation_main_details, RETRIEVE_TENANT_BUDGET_ALLOCATION_DETAILS_ERROR_MSG, RETRIEVE_TENANT_BUDGET_ALLOCATION_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIVE_TENANT_BUDGET_ALLOCATION_DETAILS_API}/${id}`));
 };

 // Listen
 const retrieve_budget_allocation_main_details_listener = useSelector((state) => state.retrieve_budget_allocation_main_details.retrieve_budget_allocation_main_details);

 useEffect(() => {
  if (retrieve_budget_allocation_main_details_listener.status !== app_consts.IDLE)
  {
   if (retrieve_budget_allocation_main_details_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    if (retrieve_budget_allocation_main_details_listener.status === app_consts.FAIL)
    {
     setLoading(false);
     setError(retrieve_budget_allocation_main_details_listener.message);
     messageToast(retrieve_budget_allocation_main_details_listener.message, app_consts.FAIL);
    } else if (retrieve_budget_allocation_main_details_listener.status === app_consts.SUCCESS)
    {
     setPageData(retrieve_budget_allocation_main_details_listener.data);

     const timer = setTimeout(() => {
      setLoading(false);
     }, 1000);

     return () => clearTimeout(timer); // cleanup in case the component unmounts
    }
    dispatch(reset_retrieve_budget_allocation_main_details());
   }
  }
 }, [retrieve_budget_allocation_main_details_listener]);

 return (
  <>{loading ? (
   <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Budget Allocation Details..." />
  ) : error ? (
   <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
  ) : (
   <>
    <div className="card-inner bg-white">
     <Block>
      <BlockHead>
       <BlockTitle tag="h5">Budget Allocation Details</BlockTitle>
      </BlockHead>
      <div className="profile-ud-list">
       <div className="profile-ud-item">
        <div className="profile-ud wider">
         <span className="profile-ud-label">Name</span>
         <span className="profile-ud-value">{page_data?.name || "--"}</span>
        </div>
       </div>
       <div className="profile-ud-item">
        <div className="profile-ud wider">
         <span className="profile-ud-label">Start Date</span>
         <span className="profile-ud-value">{page_data?.start_date ? moment(page_data?.start_date).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
        </div>
       </div>
       <div className="profile-ud-item">
        <div className="profile-ud wider">
         <span className="profile-ud-label">End Date</span>
         <span className="profile-ud-value">{page_data?.end_date ? moment(page_data?.end_date).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
        </div>
       </div>
       <div className="profile-ud-item">
        <div className="profile-ud wider">
         <span className="profile-ud-label">Amount Allocated</span>
         <span className="profile-ud-value">{page_data?.value ? `${formatNumber(parseFloat(page_data?.value)?.toFixed(2))} ZMW` : "--"}</span>
        </div>
       </div>
      </div>
      <BlockHead>
       <BlockTitle tag="h5">Agency Details</BlockTitle>
      </BlockHead>
      <div className="profile-ud-list">
       <div className="profile-ud-item">
        <div className="profile-ud wider">
         <span className="profile-ud-label">Name</span>
         <span className="profile-ud-value">{page_data?.agency?.name || "--"}</span>
        </div>
       </div>
       <div className="profile-ud-item">
        <div className="profile-ud wider">
         <span className="profile-ud-label">Mobile Number</span>
         <span className="profile-ud-value">{page_data?.agency?.mobile_number || "--"}</span>
        </div>
       </div>
       <div className="profile-ud-item">
        <div className="profile-ud wider">
         <span className="profile-ud-label">Email Address</span>
         <span className="profile-ud-value">{page_data?.agency?.email_address || "--"}</span>
        </div>
       </div>
      </div>
     </Block>
    </div>
   </>
  )
  }
  </>
 );
};

export default MainAllocationsData;